export enum ClientsWorkOverviewSortValue {
    NAME_ASC = "NAME_ASC",
    NAME_DESC = "NAME_DESC",
    APPLIED_AT_ASC = "APPLIED_AT_ASC",
    APPLIED_AT_DESC = "APPLIED_AT_DESC",
    WORK_DELIVERY_DATE_ASC = "WORK_DELIVERY_DATE_ASC",
    WORK_DELIVERY_DATE_DESC = "WORK_DELIVERY_DATE_DESC",
    PLAN_ASC = "PLAN_ASC",
    PLAN_DESC = "PLAN_DESC",
    WHO_PAYS_ASC = "WHO_PAYS_ASC",
    WHO_PAYS_DESC = "WHO_PAYS_DESC",
    SERVICE_NAME_ASC = "SERVICE_NAME_ASC",
    SERVICE_NAME_DESC = "SERVICE_NAME_DESC",
    ENTITY_ASC = "ENTITY_ASC",
    ENTITY_DESC = "ENTITY_DESC",
    SERVICE_PERIOD_ASC = "SERVICE_PERIOD_ASC",
    SERVICE_PERIOD_DESC = "SERVICE_PERIOD_DESC",
    WORK_START_ASC = "WORK_START_ASC",
    WORK_START_DESC = "WORK_START_DESC",
    DAYS_IN_STAGE_ASC = "DAYS_IN_STAGE_ASC",
    DAYS_IN_STAGE_DESC = "DAYS_IN_STAGE_DESC",
    ENGAGEMENT_TEAM_COUNT_ASC = "ENGAGEMENT_TEAM_COUNT_ASC",
    ENGAGEMENT_TEAM_COUNT_DESC = "ENGAGEMENT_TEAM_COUNT_DESC",
    PROGRESS_ASC = "PROGRESS_ASC",
    PROGRESS_DESC = "PROGRESS_DESC",
    ESTIMATED_TIME_ASC = "ESTIMATED_TIME_ASC",
    ESTIMATED_TIME_DESC = "ESTIMATED_TIME_DESC",
    APPLICATION_TYPE_ASC = "APPLICATION_TYPE_ASC",
    APPLICATION_TYPE_DESC = "APPLICATION_TYPE_DESC",
    APPLIED_BY_ASC = "APPLIED_BY_ASC",
    APPLIED_BY_DESC = "APPLIED_BY_DESC",
    UNREAD_TASKS_ASC = "UNREAD_TASKS_ASC",
    UNREAD_TASKS_DESC = "UNREAD_TASKS_DESC",
    HEALTH_ASC = "HEALTH_ASC",
    HEALTH_DESC = "HEALTH_DESC",
    CREATED_AT_ASC = "CREATED_AT_ASC",
    CREATED_AT_DESC = "CREATED_AT_DESC",
}
